import React from "react";
import { useNavigate } from "react-router-dom";
import { formatFirestoreDate } from "../../../utils/date_formatter";

const EventCard = ({ event }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/events/${event.id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="w-[180px] sm:w-[200px] md:w-[220px] h-auto sm:h-[350px] md:h-[389px] flex-shrink-0 cursor-pointer group transition-all duration-300 ease-out hover:scale-[1.02]"
    >
      {/* Card Container */}
      <div className="bg-transparent rounded-xl shadow-lg group-hover:shadow-xl transition-all duration-300 h-full flex flex-col">

        {/* Image Container */}
        <div className="relative w-full h-[200px] sm:h-[240px] md:h-[280px] flex-shrink-0 overflow-hidden rounded-xl">
          <img
            src={event.poster?.verticalUrl || event.poster?.horizontalUrl}
            alt={event.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>

        {/* Content Area - EXACT DESIGN MATCH */}
        <div className="mt-3 flex flex-col flex-1 min-h-0">
          {/* Event Title - White, Bold, 2 lines max */}
          <h2 className="text-white text-[14px] leading-[17px] font-medium mb-2" style={{
            fontFamily: 'Poppins',
            fontWeight: 500,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: '34px'
          }}>
            {event.name}
          </h2>

          {/* Date - Gray, on its own line */}
          <div className="text-[12px] leading-[14px] font-normal mb-1" style={{
            color: '#B3B3B3',
            fontFamily: 'Poppins',
            fontWeight: 400
          }}>
            {formatFirestoreDate(event.startTime)}
          </div>

          {/* Venue - Gray, below date */}
          <div className="text-[12px] leading-[14px] font-normal" style={{
            color: '#B3B3B3',
            fontFamily: 'Poppins',
            fontWeight: 400
          }}>
            {event.eventLocation?.locationText || 'Location TBA'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
